import { render, staticRenderFns } from "./Profitloss_Result_Chart.vue?vue&type=template&id=4b61741e&"
import script from "./Profitloss_Result_Chart.vue?vue&type=script&lang=js&"
export * from "./Profitloss_Result_Chart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports